import { AIPService } from 'src/app/services/aip.service';
import { AfterViewInit, Component, Inject, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { DOCUMENT } from '@angular/common';
import { PosthogService } from 'src/app/services/posthog.service';

@Component({
  selector: 'app-success',
  templateUrl: './success.component.html',
  styleUrls: ['./success.component.scss'],
})
export class SuccessComponent implements OnInit, AfterViewInit {
  amount!: number;

  constructor(
    private readonly aipService: AIPService,
    private readonly router: Router,
    @Inject(DOCUMENT) private readonly document: Document,
    private readonly posthogService: PosthogService
  ) {
    console.error('success loaded >>>');
  }

  get canRedirect(): boolean {
    return (
      !!this.aipService.transactionDetails?.callBackUrl &&
      this.aipService.transactionDetails.callBackUrl.trim() !== ''
    );
  }

  ngOnInit(): void {
    this.amount = this.aipService.transactionDetails.paymentAmount;

    this.posthogService.trackSuccessPageViewed({
      amount: this.amount,
      reference: this.aipService.transactionDetails?.reference,
    });
  }

  ngAfterViewInit(): void {
    if (!this.aipService.transactionDetails) {
      this.router.navigate(['/', 'not-found']);
      return;
    }
    setTimeout(() => {
      window.parent.postMessage(true, '*');
      const callBackUrl = this.aipService.transactionDetails.callBackUrl;
      if (callBackUrl && callBackUrl.trim() !== '') {
        this.document.location.href = callBackUrl;
      }
    }, 1500);
  }
}
